// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".google__layout{display:flex}@media screen and (max-width:729px){.google__layout{display:block}}.google__sidebar{position:relative;min-width:30%;display:flex;flex-direction:column;max-height:800px}.google__main{padding-left:24px;flex:1 0 auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
